export const getFirstImage = (image) => {
  if (!image) return "";

  if (typeof image === "string") {
    return (
      image
        .split(",")
        .map((url) => url.trim())
        .filter(Boolean)[0] || ""
    );
  }

  if (Array.isArray(image)) {
    const first = image[0];

    if (typeof first === "string") {
      return (
        first
          .split(",")
          .map((url) => url.trim())
          .filter(Boolean)[0] || ""
      );
    }

    if (first && typeof first === "object") {
      return first.url || first.image || first.src || first.path || "";
    }
  }

  if (typeof image === "object") {
    return image.url || image.image || image.src || image.path || "";
  }

  return "";
};

export const getProductPrices = (product) => {
  if (!product) return [];
  if (Array.isArray(product.prices)) return product.prices;
  if (Array.isArray(product.productPrices)) return product.productPrices;
  if (Array.isArray(product.priceOptions)) return product.priceOptions;
  if (Array.isArray(product.data?.prices)) return product.data.prices;
  return [];
};

export const calculatePrice = (product, selectedPrice, quantity) => {
  const priceType = Number(product?.priceType);
  let basePrice = 0;

  if (priceType === 1) {
    basePrice = Number(selectedPrice?.price ?? 0);
  } else {
    basePrice = Number(product?.basePrice ?? 0);
  }
  if (!Number.isFinite(basePrice)) basePrice = 0;

  let discountedPrice = basePrice;
  const offer = product?.offer;

  if (offer?.isActive && offer?.offerType !== null && offer?.offerType !== undefined) {
    const offerType = Number(offer.offerType);
    const offerValue = Number(offer.offerValue ?? 0);
    if (offerType === 0) discountedPrice = basePrice - (basePrice * offerValue) / 100;
    else if (offerType === 1) discountedPrice = basePrice - offerValue;
  }

  if (Array.isArray(offer?.offerTiers) && offer.offerTiers.length > 0) {
    const tiers = [...offer.offerTiers].sort(
      (a, b) => Number(a?.minQuantity ?? 0) - Number(b?.minQuantity ?? 0),
    );
    let selectedTier = null;
    for (const tier of tiers) {
      const minQuantity = Number(tier?.minQuantity ?? tier?.quantity ?? tier?.minQty ?? 0);
      if (quantity >= minQuantity) selectedTier = tier;
    }
    if (selectedTier) {
      const tierType = Number(selectedTier.offerType ?? selectedTier.discountType ?? 0);
      const tierValue = Number(selectedTier.offerValue ?? selectedTier.discountValue ?? 0);
      if (tierType === 0) discountedPrice = basePrice - (basePrice * tierValue) / 100;
      else if (tierType === 1) discountedPrice = basePrice - tierValue;
    }
  }

  discountedPrice = Math.max(0, Number(discountedPrice.toFixed(2)));
  return { basePrice, discountedPrice };
};